export var VisibilityInStudentDialoguesEnum;
(function (VisibilityInStudentDialoguesEnum) {
    VisibilityInStudentDialoguesEnum["ALL"] = "all";
    VisibilityInStudentDialoguesEnum["COURSE_RELATED"] = "course-related";
    VisibilityInStudentDialoguesEnum["NOBODY"] = "nobody";
})(VisibilityInStudentDialoguesEnum || (VisibilityInStudentDialoguesEnum = {}));
